
import { Component, Prop, Vue } from 'vue-property-decorator'
import ParamBox from '@/components/ParamBox.vue'

@Component({
  components: {
    ParamBox
  }
})
export default class ParamInfoBox extends Vue {
  @Prop({ default: 'UNTITLED' }) title!: string;
  @Prop({ default: 'list' }) icon!: string;
}
